import { render, staticRenderFns } from "./ChannelSearch.vue?vue&type=template&id=4ac5eb08"
import script from "./ChannelSearch.vue?vue&type=script&lang=js"
export * from "./ChannelSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports